const parseQuery = (query) => {
  if (!query || typeof query !== 'string') {
    return {};
  }

  return Object.fromEntries(
    decodeURIComponent(query)
      .split('&')
      .map((v) => v.split('=')),
  );
};

export default parseQuery;
